module.exports = __webpack_public_path__ + "media/navigation/icon-making-our-meals-5b4caf4d.svg";